import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { addlog } from "../../utils/ApiCalls/Logs";
import {
  createSailingPageData,
  getSailingPageData,
  updateSailingPageData,
} from "../../utils/ApiCalls/SailingData";
import { CRUISE_PAGE_LOG_TYPES } from "../../constants/logging";
import {
  getParentSailingDate,
  getParentSailingPage,
  getSailingDate,
} from "../../utils/ApiCalls/SailingDates";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import { MenuItem, Select } from "@mui/material";
const SailingPageInputs = ({ newsletter }) => {
  const [sailing_date, setSailingDate] = useState();
  const [sailing_data, setSailingData] = useState();
  const [sailingDateOptions, setSailingDateOptions] = useState([]);
  const params = useParams();
  const [vessel_id, setVessel_id] = useState();
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [vesselOptions, setVesselOptions] = useState([]);
  // const [sailingOptions, setsailingOptions] = useState([]);
  const navigate = useNavigate();
  const [dataValues, setDataValues] = useState({});

  // const validDates = sailingOptions?.map((item) =>
  //   moment(item.sailing_date).startOf("day")
  // );
  useEffect(() => {
    getOptionLocation();
  }, []);

  const addData = async (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let added = false;

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();
      let sailing = sailingDateOptions.find(
        (item) => item.packageId == sailing_date
      );

      const currentDate = moment(sailing?.sailing_date).startOf("day").toDate();
      const lastDate = moment(sailing?.sailing_date)
        .add(sailing?.duration, "days") // ✅ specify unit
        .endOf("day")
        .toDate();
      let dataValues = {
        sailing_date: moment(sailing?.sailingDate).format("YYYY-MM-DD"),
        end_date: moment(sailing?.sailingEndDate).format("YYYY-MM-DD"),
        vessel_id,
        duration: sailing?.duration,
        package_id: sailing?.packageId,
      };

      const values = {
        ...dataValues,
      };

      let data;
      if (newsletter?.id) {
        data = await updateSailingPageData(newsletter.id, values);
      } else {
        data = await createSailingPageData(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        return;
      } else {
        added = true;
        
        const vesselName = vesselOptions.find(v => v.id === vessel_id)?.name || "Unknown Vessel";
        const isUpdate = !!newsletter?.id;
        const startDate = moment(sailing?.sailingDate);
        const endDate = startDate.clone().add(sailing?.duration || 7, 'days');
        const cruiseTitle = `${startDate.format("DD MMM")} to ${endDate.format("DD MMM YYYY")} / ${sailing?.duration || 7} Nights`;
        
        await addlog(
          isUpdate ? CRUISE_PAGE_LOG_TYPES.ACTIONS.CRUISE_PAGE_UPDATED : CRUISE_PAGE_LOG_TYPES.ACTIONS.CRUISE_PAGE_CREATED,
          CRUISE_PAGE_LOG_TYPES.MODULE,
          {
            title: `${vesselName} - ${cruiseTitle}`,
            vessel_name: vesselName,
            sailing_date: moment(sailing?.sailingDate).format("YYYY-MM-DD"),
            end_date: moment(sailing?.sailingEndDate).format("YYYY-MM-DD"),
            duration: sailing?.duration || 7,
            package_id: sailing?.packageId,
            vessel_id: vessel_id
          },
          userDetails.id
        );
      }
      if (added) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { 
            message: newsletter?.id ? "Cruise page updated successfully" : "Cruise page created successfully", 
            type: "success" 
          },
        });
        navigate(`/shore/cruise-page/${params.vessel}`);
      }
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (vessel_id) {
      getSailingDates();
    }
  }, [vessel_id]);

  useEffect(() => {
    if (params?.vessel && vesselOptions) {
      setVessel_id(
        vesselOptions.find(
          (item) =>
            item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
        )?.id
      );
    }
  }, [params, vesselOptions]);

  const getSailingDates = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let lastSailing = await getSailingPageData({ limit: 1, vessel_id });
    let res = await getParentSailingPage(vessel_id);
    setSailingDateOptions(res?.data);
    console.log({ res });
    let data = await getSailingDate({
      page: 1,
      limit: 1,
      vessel_id: vessel_id,
      ...(lastSailing?.data?.[0]?.end_date
        ? {
          sailingDate: moment(lastSailing.data[0].end_date).format(
            "YYYY-MM-DD"
          ),
        }
        : {}),
    });
    if (data?.data?.length > 0) {
      const sailing = data.data[0];

      const duration = sailing?.cruisePackage?.duration || 0;
      setSailingData(sailing?.sailingDate);
      const currentDate = moment(sailing?.sailing_date).startOf("day").toDate();
      const lastDate = moment(sailing?.sailing_date)
        .add(duration, "days") // ✅ specify unit
        .endOf("day")
        .toDate();

      const ids = await getSailingDate({
        page: 1,
        vessel_id,
        startDate: currentDate,
        endDate: lastDate,
      });

      let dataValues = {
        sailing_date: moment(currentDate).format("YYYY-MM-DD"),
        end_date: moment(lastDate).format("YYYY-MM-DD"),
        vessel_id,
        duration: sailing?.cruisePackage?.duration,
        package_ids: ids?.data?.filter(
          (item) => item.cruisePackage?.duration < sailing?.duration
        ),
        package_id: sailing?.cruisePackage?.package_id,
      };
      setDataValues(dataValues);

      console.log(dataValues);
      setSailingData(sailing);
    }
    // setsailingOptions(data?.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  //USING THIS INSIDE SELECT & OPTIONS TO RENDER FORMATED TEXT |  ------------------------------------------------------------
  const renderSailingOption = (item) => {
    const menuOption = `${moment(item?.sailingDate).format("DD MMM")} to ${moment(item?.sailingEndDate).format("DD MMM YYYY")} / ${item?.duration} Nights`;
    return (
      <span style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
        <span
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginRight: 8, display: "inline-block", verticalAlign: "middle" }}
          title={menuOption}
        >
          {menuOption}
        </span>
      </span>
    );
  };

  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addData}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Sailing Date</label>
                      <Select
                        required
                        style={{ width: "100%", height: "45px" }}
                        value={sailing_date}
                        onChange={(e) => {
                          setSailingDate(e.target.value);
                        }}
                      >
                        {sailingDateOptions.map((item, index) => {
                          return (
                            <MenuItem key={index + ""} value={item?.packageId}>
                              {renderSailingOption(item)}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {newsletter.id ? "Update" : "Add"} Cruise Page
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default SailingPageInputs;
